import request from '../../utils/request'
import {API} from '../../utils/constant'

export default {
  getCompany (params) {
    return request.get(API.ADMIN_COMPANY, params)
  },
  createCompany (params) {
    return request.post(API.ADMIN_COMPANY, params)
  },
  copyCompany (params) {
    return request.post(API.ADMIN_COMPANY_COPY + params.id, params.copyData)
  },
  getDetailCompany (params) {
    return request.get(API.ADMIN_COMPANY_GET + params, params)
  },
  updateCompany (params) {
    return request.post(API.ADMIN_COMPANY_GET + params.id, params.formData)
  },
  deleteCompany (params) {
    return request.delete(API.ADMIN_COMPANY_GET + params)
  },
  getParentCompanies (params) {
    return request.get(API.ADMIN_PARENT_COMPANIES, params)
  }
}



// WEBPACK FOOTER //
// ./src/api/admin/company.js